import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import VueBarcode from 'vue-barcode'
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'
import CryptoJS from 'crypto-js'
import {
	Validator
} from 'vee-validate'
// import Printd from 'printd'
export default {
	name: 'po',
	components: {
		Paginate,
		VueElementLoading,
		'barcode': VueBarcode
	},

	data: function () {
		return {
			isLoading: false,
			listShippingDetailsData: [],
			shipmentDetailsStatus: [],
			listOrderMasterdata: [],
			shipMasterData: [],
			shipcount: 0,
			shipmentDetailsCount: 0,
			orderDetailsCount: 0,
			pagecountship: 0,
			pagecountorder: 0,
			urlclientid: '',
			urlwarehouseid: '',
			poid: '',
			pono: '',
			// initialize form field
		}
	}, // end data
	created: function () { },
	filters: {
		moment: function (date) {
			return moment(date).format('DD-MM-YYYY');
		},

	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		var loginuseremail = userdetail.email;
		this.loginwarehouseid = userdetail.warehouseid;
		this.loginClientUserId = userdetail.clientid;
		this.getorderDetails();
	},
	methods: {
		getScore(val) {
			if (!val) {
				return 0.00
			}
			return val.toFixed(2);
		},
		toUpper(str) {
			if (str !== null && str !== undefined) {
				return str.charAt(0).toUpperCase() + str.slice(1);
			} else {
				return '--'
			}
		},
		dateFormatDetail(date) {
			if (!date) return '';
			return moment(date).format('LLLL');
		},
		getorderDetails() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pono = this.$route.params.poid;
			this.urlclientid = this.loginClientUserId ? this.loginClientUserId : this.$route.query.clientid
			this.urlwarehouseid = this.loginwarehouseid ? this.loginwarehouseid : this.$route.query.warehouseid
			this.poid = this.pono;
			this.isLoading = true;
			this.input = ({
				pono: this.pono,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
				type: "ShippingDetails"
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getSingleOrderDetailsUpdatedForTab',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.isLoading = false;
					this.shipmentDetailsStatus = result.data.data.shipmentstatusDetails
					this.shipmentDetailsCount = Object.keys(this.shipmentDetailsStatus).length;
					this.listOrderMasterdata = result.data.data.orderMaster;
					this.orderDetailsCount = this.listOrderMasterdata.length;
					this.listShippingDetailsData = result.data.data.shipping_data;
					this.shipMasterData = result.data.data.shipping_data[0];
					this.shipcount = result.data.data.shipCount
					let totalRows = result.data.data.shipCount;
					if (totalRows < 10) {
						this.pagecountship = 1
						this.pagecountorder = 1
					} else {
						this.pagecountship = Math.ceil(totalRows / 10)
					}
				},
					error => {
						console.error(error)
					})
		},
	} // end methods
}



// WEBPACK FOOTER //
// ./src/views/components/orderdetailstab/shippingdetails/shippingdetails.component.js